import { UserModel } from '../profile/symbols';

export interface TelegramChatModel {
  id: string;
  createdAt: string;
  chatId: number;
  firstName: string;
  lastName: string;
  username: string;
  messagesIds: string[];
  phone?: string;
  lastMessage: TelegramChatMessageModel;
  telegramBot: TelegramBotModel;
}

export interface TelegramChatMessageModel {
  id: string;
  createdAt: string;
  ctx: number;
  message: string;
  firstName: string;
  lastName: string;
  username: string;
  isRead: boolean;
  photo?: string | null;
  video?: string | null;
  chatId: string; // This should match the TelegramChatModel's id
  manager?: UserModel
  videoUrl?: string;
  photoUrl?: string;
}

interface TelegramBotModel {
  id: string;
  tel: string;
  chatId: number;
  avatarPath: string;
}

// Telegram Bot API приймає файли до 50 МБ
export const TELEGRAM_MAX_MEDIA_SIZE = 50 * 1024 * 1024;
